<div class="col-12 tab-carousel">
  <div class="tabs-container" role="tablist">
    <ul>
      @for (item of items; track item) { @if (item.isHide ? !(item.isHide |
      async) : true) {
      <li
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: item.exact }"
        matRipple
      >
        <a [routerLink]="item.link" [ngStyle]="linkStyle">
          <icon [type]="item.icon"></icon>
          {{ item.label }}
        </a>
      </li>
      } }
    </ul>
  </div>
</div>

<div class="tabs-content" role="tabpanel"><ng-content></ng-content></div>
